import { createSelector } from 'reselect';

const selectForums = (state: any) => state.forums;


export const selectForumsCurrentItem = createSelector([selectForums], (forums) => forums.current);

export const selectForumsListItems = createSelector([selectForums], (forums) => forums.list);

export const selectForumsItemById = (itemId: any) =>
    createSelector(selectForumsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectForumsQueryItems = createSelector([selectForums], (forums) => forums.query);

export const selectForumsCreatedItem = createSelector([selectForums], (forums) => forums.create);

export const selectForumsUpdatedItem = createSelector([selectForums], (forums) => forums.update);

export const selectForumsReadItem = createSelector([selectForums], (forums) => forums.read);

export const selectForumsDeletedItem = createSelector([selectForums], (forums) => forums.delete);

export const selectForumsSearchedItems = createSelector([selectForums], (forums) => forums.search);

export const selectForumsItemsCount = createSelector([selectForums], (forums) => forums.count);

export const selectForumsItemsFilter = createSelector([selectForums], (forums) => forums.filter);